

export const waveEdgeClipPath = `
      0% 100%,
      100% 100%,
      100% 42.211%,
      100% 42.211%,
      99.554% 41.272%,
      98.295% 38.717%,
      96.339% 34.94%,
      93.803% 30.336%,
      90.803% 25.297%,
      87.455% 20.219%,
      83.876% 15.496%,
      80.184% 11.52%,
      76.493% 8.687%,
      72.921% 7.39%,
      72.921% 7.39%,
      69.525% 7.981%,
      65.922% 10.262%,
      62.148% 13.865%,
      58.236% 18.427%,
      54.222% 23.581%,
      50.14% 28.962%,
      46.025% 34.204%,
      41.912% 38.942%,
      37.834% 42.809%,
      33.827% 45.441%,
      33.827% 45.441%,
      29.672% 45.701%,
      25.24% 43.137%,
      20.699% 38.407%,
      16.217% 32.17%,
      11.963% 25.086%,
      8.105% 17.812%,
      4.812% 11.007%,
      2.251% 5.331%,
      0.591% 1.443%,
      0% 0%,
      0% 100%
    `
